import { useState } from "react";
import { useForm } from "react-hook-form";

import { FormDialog } from "ui/form-dialog";
import AddTouchpointsForm from "containers/admin/clients/client/approval-queue/batch-details/components/add-touchpoints-form/add-touchpoints-form";

import { ADD_TOUCHPOINTS_TO_BATCH_VALIDATION_SCHEMA } from "containers/admin/clients/client/approval-queue/batch-details/batch-details.consts";

type AddTouchpointsValues = {
  chosenCampaign: string | { label: string; value: string };
  chosenTouchpoints: { value: string }[];
};

type AddTouchpointsDialogProps = {
  clientId: string;
  batchId: string;
  campaignOptions: { label: string; value: string }[];
  onSubmit: (values: { chosenTouchpoints: { value: string }[] }) => void | Promise<unknown>;
  onClose: () => void;
};

export const AddTouchpointsDialog = ({
  clientId,
  batchId,
  campaignOptions,
  onSubmit,
  onClose,
}: AddTouchpointsDialogProps) => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const form = useForm<AddTouchpointsValues>({
    mode: "onChange",
    shouldUnregister: true,
    defaultValues: { chosenCampaign: "", chosenTouchpoints: [] },
    resolver: ADD_TOUCHPOINTS_TO_BATCH_VALIDATION_SCHEMA,
  });

  return (
    <FormDialog
      open
      onClose={onClose}
      headline="Add to batch"
      description="Please choose campaign and creatives you want to include in this batch."
      form={form}
      onSubmit={onSubmit}
      submitDisabled={isSubmitDisabled}
      submitButtonText="Add to batch"
      submitLoadingMessage="Adding to batch...">
      <AddTouchpointsForm
        clientId={clientId}
        batchId={batchId}
        currentCampaignsOptions={campaignOptions}
        setAddingToBatchSubmitIsDisabled={setIsSubmitDisabled}
      />
    </FormDialog>
  );
};
